import { render, staticRenderFns } from "./ShipbackReqPop.vue?vue&type=template&id=75a6f378&scoped=true"
import script from "./ShipbackReqPop.vue?vue&type=script&lang=js"
export * from "./ShipbackReqPop.vue?vue&type=script&lang=js"
import style0 from "./ShipbackReqPop.vue?vue&type=style&index=0&id=75a6f378&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a6f378",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75a6f378')) {
      api.createRecord('75a6f378', component.options)
    } else {
      api.reload('75a6f378', component.options)
    }
    module.hot.accept("./ShipbackReqPop.vue?vue&type=template&id=75a6f378&scoped=true", function () {
      api.rerender('75a6f378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShipbackReqPop.vue"
export default component.exports